import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import FullWidthModal from '../Modal/FullWidthModal';
import ModalHeader from '../ModalHeader/index';
import { TouchableButton } from '../Touchable/index';
import CustomKeyboard from '@components/common/CustomKeyboardCopy/indexRevamp';
import { LABEL, CUSTOM_MESSAGES } from '../../../veriables';

const OfflinePayScreenLandscape = props => {
  const {
    isOfflineScreen,
    setIsOfflineScreen,
    serverAppTheme,
    setErrorPopUp,
    handleOfflinePayment,
    inputs,
    setInputs,
    setOfflineVoid,
    INITIAL_INPUTS
  } = props;

  const [typed, setTyped] = useState({});
  const [inputName, setInputName] = useState('checkName');
  const [keyboardType, setKeyboardType] = useState('numericAlpha');
  const inputRefs = useRef({});
  const REQUIRED_FIELDS = [
    { key: 'checkName', message: LABEL().OFFLINE_PLEASE_ENTER_NAME },
    { key: 'orderId', message: LABEL().OFFLINE_PLEASE_ENTER_CHECK_NUMBER },
    { key: 'amount1', message: LABEL().OFFLINE_PLEASE_ENTER_SUBTOTAL_AMOUNT },
    { key: 'amount2', message: LABEL().OFFLINE_PLEASE_ENTER_TAX_AMOUNT },
  ];

  useEffect(() => {
    const a1 = parseFloat(inputs.amount1) || 0;
    const a2 = parseFloat(inputs.amount2) || 0;

    const total = (a1 + a2).toFixed(2);

    setInputs(prev => ({
      ...prev,
      totalAmount: total,
    }));
  }, [inputs.amount1, inputs.amount2]);

  const formatAmount = value => {
    if (!value) return '';
    return `$${value}`;
  };

  const onClickBtn = e => {
    if (!inputName || inputName === 'totalAmount') return;

    const rawValue = inputs[inputName]?.replace('$', '') || '';

    const updatedValue = e === '{bksp}' ? rawValue.slice(0, -1) : rawValue + e;

    setInputs(prev => ({
      ...prev,
      [inputName]: updatedValue,
    }));

    setTyped(prev => ({
      ...prev,
      [inputName]: updatedValue,
    }));
  };

  const validateAndPay = () => {
    for (const field of REQUIRED_FIELDS) {
      const value = inputs[field.key];

      if (!value || value.trim() === '') {
        setErrorPopUp({
          res: field.message,
        });

        return;
      }
    }

    handleOfflinePayment();
  };

  const handleOfflineCancel = () => {
    setInputs(INITIAL_INPUTS);
    setTyped({});
    setInputName('');
    setIsOfflineScreen(false);
  }

  return (
    <>
      <FullWidthModal
        isOpen={isOfflineScreen}
        noBackground
        customClass={cn('h-100')}
        customClass2="h-100 w-100"
        customWidth={true}
        style={{ backgroundColor: serverAppTheme?.popUp_bg, height: '100%' }}
      >
        <div className="col-12 justify-content-center align-items-center position-relative text-center h-100 px-0">
          <div className="col-12 px-0 h-100">
            {/* 1. header */}
            <ModalHeader
              stationName=""
              tileHeader={CUSTOM_MESSAGES().OFFLINE_TRANSACTIONS}
              seatNumber=""
            />

            {/* 2. all inputs */}
            <div className="col-12 mt-3">
              <div className={cn('col-12 d-flex p-0')}>
                {/* 2.1 name */}
                <div
                  className="col-6 pl-0 pr-2 fs_24 fw-600 d-flex w-100 position-relative align-items-center mb-12"
                  tabIndex="0"
                  role="button"
                  style={{
                    height: '2.75rem',
                  }}
                >
                  <input
                    ref={el => (inputRefs.current.checkName = el)}
                    name="checkName"
                    className="col-12 h-100 fs_24 text-left"
                    value={inputs.checkName}
                    onFocus={e => {
                      e.target.blur();
                      setInputName('checkName');
                    }}
                    style={{
                      background: serverAppTheme?.inputBg,
                      border: 'none',
                      borderBottom: serverAppTheme?.inputBorder_Bottom,
                      color: serverAppTheme?.primary_text,
                      '--placeholder-color': serverAppTheme?.input_placeholder,
                    }}
                    placeholder={LABEL().OFFLINE_ENTER_NAME}
                    autoFocus={keyboardType}
                  />
                </div>
                {/* 2.2 Check Number */}
                <div
                  className="col-6 pr-0 pl-2 fs_24 fw-600 d-flex w-100 position-relative align-items-center mb-12"
                  tabIndex="0"
                  role="button"
                  style={{
                    height: '2.75rem',
                  }}
                >
                  <input
                    ref={el => (inputRefs.current.orderId = el)}
                    name="orderId"
                    className="col-12 h-100 fs_24 text-left"
                    value={`${inputs.orderId}`}
                    onFocus={e => {
                      e.target.blur();
                      setInputName('orderId');
                    }}
                    style={{
                      background: serverAppTheme?.inputBg,
                      border: 'none',
                      borderBottom: serverAppTheme?.inputBorder_Bottom,
                      color: serverAppTheme?.primary_text,
                      '--placeholder-color': serverAppTheme?.input_placeholder,
                    }}
                    placeholder={LABEL().OFFLINE_ENTER_CHECK_NUMBER}
                  />
                </div>
              </div>
              <div className={cn('col-12 p-0 d-flex')}>
                {/* 2.3 Subtotal Amount */}
                <div
                  className="col-4 pl-0 pr-2 fs_24 fw-600 d-flex w-100 position-relative align-items-center mb-12"
                  tabIndex="0"
                  role="button"
                  style={{
                    height: '2.75rem',
                  }}
                >
                  <input
                    ref={el => (inputRefs.current.amount1 = el)}
                    name="amount1"
                    className="col-12 h-100 fs_24 text-left"
                    value={formatAmount(inputs.amount1)}
                    onFocus={e => {
                      e.target.blur();
                      setInputName('amount1');
                    }}
                    style={{
                      background: serverAppTheme?.inputBg,
                      border: 'none',
                      borderBottom: serverAppTheme?.inputBorder_Bottom,
                      color: serverAppTheme?.primary_text,
                      '--placeholder-color': serverAppTheme?.input_placeholder,
                    }}
                    placeholder={LABEL().OFFLINE_ENTER_SUBTOTAL}
                  />
                </div>
                {/* 2.4 Tax Amount */}
                <div
                  className="col-4 pl-2 pr-2 fs_24 fw-600 d-flex w-100 position-relative align-items-center mb-12"
                  tabIndex="0"
                  role="button"
                  style={{
                    height: '2.75rem',
                  }}
                >
                  <input
                    ref={el => (inputRefs.current.amount2 = el)}
                    name="amount2"
                    className="col-12 h-100 fs_24 text-left"
                    value={formatAmount(inputs.amount2)}
                    onFocus={e => {
                      e.target.blur();
                      setInputName('amount2');
                    }}
                    style={{
                      background: serverAppTheme?.inputBg,
                      border: 'none',
                      borderBottom: serverAppTheme?.inputBorder_Bottom,
                      color: serverAppTheme?.primary_text,
                      '--placeholder-color': serverAppTheme?.input_placeholder,
                    }}
                    placeholder={LABEL().OFFLINE_ENTER_TAX}
                  />
                </div>
                {/* 2.5 Total Amount */}
                <div
                  className="col-4 pr-0 pl-2 fs_24 fw-600 d-flex w-100 position-relative align-items-center mb-12"
                  style={{
                    height: '2.75rem',
                    borderRadius: '4px',
                  }}
                >
                  <input
                    className="col-12 h-100 fs_24 text-left px-2"
                    value={`$${inputs.totalAmount}`}
                    readOnly
                    tabIndex={-1}
                    style={{
                      opacity: '0.9',
                      backgroundColor: '#E0E0E0',
                      border: 'none',
                      outline: 'none',
                      color: '#494949',
                      fontWeight: 600,
                      pointerEvents: 'none',
                    }}
                  />
                </div>
              </div>
            </div>
            {/* 3. keyboard */}
            <CustomKeyboard
              setKeyboardType={setKeyboardType}
              onClickBtn={e => onClickBtn(e)}
              type={
                inputName === 'checkName'
                  ? 'textDefaultCaps'
                  : inputName === 'orderId'
                    ? "numericAlpha"
                    : 'withoutDone'
              }
              typed={typed[inputName] || ''}
              btnSize="fs-18"
              customClass={`h-auto mt-auto p-2`}
              screenType="checkCreate"
              isAlphaNumericFlag={true}
              isOfflinePay={true}
            />
            {/* 4. buttons */}
            <div
              className={cn(
                'align-items-center col-12 d-flex justify-content-center position-absolute'
              )}
              style={{
                bottom: '1rem',
              }}
            >
              <div className="col-12 d-flex justify-content-center p-0">
                <div className="col-12 d-flex justify-content-center p-0 w-100">
                  <div className="col-6 d-flex justify-content-end w-70">
                    <TouchableButton
                      type="button"
                      className={cn(
                        'w-70 px-0 rounded btn-ripple fw-600 fs_28'
                      )}
                      onClick={e => {
                        e.preventDefault();
                        handleOfflineCancel();
                      }}
                      style={{
                        height: '2.75rem',
                        backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                        border: serverAppTheme?.cancleBtn_Border,
                        color: serverAppTheme?.cancleBtn_font,
                      }}
                    >
                      {LABEL().OFFLINE_CANCEL}
                    </TouchableButton>
                  </div>

                  <div className="col-6 pl-1 pr-0 w-100 d-flex">
                    <TouchableButton
                      style={{
                        height: '2.75rem',
                        backgroundColor: serverAppTheme?.secondaryBtn,
                        color: serverAppTheme?.btn_font_color,
                      }}
                      className="w-70 fw-600 fs_28 border-0 rounded"
                      onClick={e => {
                        e.preventDefault();
                        validateAndPay();
                        setOfflineVoid(true);
                      }}
                    >
                      {LABEL().OFFLINE_PAY}
                    </TouchableButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FullWidthModal>
    </>
  );
};

export default OfflinePayScreenLandscape;
